import { render, staticRenderFns } from "./fieldXButtonRemoveParentBabyBinding.vue?vue&type=template&id=5c4decc9&"
import script from "./fieldXButtonRemoveParentBabyBinding.vue?vue&type=script&lang=js&"
export * from "./fieldXButtonRemoveParentBabyBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/bsx-uat.dianthus.com.tw/backstage_orig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4decc9')) {
      api.createRecord('5c4decc9', component.options)
    } else {
      api.reload('5c4decc9', component.options)
    }
    module.hot.accept("./fieldXButtonRemoveParentBabyBinding.vue?vue&type=template&id=5c4decc9&", function () {
      api.rerender('5c4decc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/vueFormFieldComponents/fieldXButtonRemoveParentBabyBinding.vue"
export default component.exports